module.exports = __webpack_public_path__ + "static/media/portfolio11.9a21d572.jpeg";